export default "__VITE_ASSET__67aa87d3__$_?nuxt_component=async__"